import { render, staticRenderFns } from "./form-prepa-versement.vue?vue&type=template&id=fd998d6c&scoped=true"
import script from "./form-prepa-versement.vue?vue&type=script&setup=true&lang=js"
export * from "./form-prepa-versement.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd998d6c",
  null
  
)

export default component.exports